module.exports = __webpack_public_path__ + "assets/4100474079614ba1aee0d66de2b858da.png";